import { render, staticRenderFns } from "./CommonPopover.vue?vue&type=template&id=be2c641c"
import script from "./CommonPopover.vue?vue&type=script&lang=js"
export * from "./CommonPopover.vue?vue&type=script&lang=js"
import style0 from "./CommonPopover.vue?vue&type=style&index=0&id=be2c641c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports